import { gql } from "@apollo/client";

export const GET_RATE_LIMITS = gql`
  query getRateLimits {
    listProviderRateLimits {
      providerRateLimitKey
      tokenRatePerSecond
    }
    listLaneRateLimits {
      providerRateLimitKey
      lane
      tokenRatePerSecond
    }
  }
`;

export const GET_LANE_USAGE = gql`
  query getLaneUsage {
    getLaneUsage {
      providerRateLimitKey
      lane
      timestamp
      count
    }
  }
`;

export const UPDATE_LANE_RATE_LIMITS = gql`
  mutation updateLaneRateLimits($input: UpdateLaneRateLimitsInput!) {
    updateLaneRateLimits(input: $input)
  }
`;
